import {ShapeCommand} from '../commands.template';

export class StickerChangeStyleCommand extends ShapeCommand {
  services: any;
  reverseStyleChange: any;

  constructor(data) {
    super(data);
  }

  prepareData() {
    const stickerJson = this.services.jsonHandlerSvc.get().notes.find(t => {
      return Number(t.mxKey) === Number(this.object.mxKey);
    });

    this.reverseStyleChange = {
      mxKey: stickerJson?.mxKey,
      style: {paperClass: stickerJson?.paperClass},
      customStyle: stickerJson?.customStyle
    };

    return this;
  }

  public execute() {
    super.execute();

    return this.sendChanges(this.object);
  }

  public reverse() {
    super.reverse();

    return this.sendChanges(this.reverseStyleChange);
  }

  private sendChanges(styleChange) {
    const mxStyles = ['paperClass'];
    const ourStyles = ['paperClass'];
    const isCustom = !!styleChange.style;

    this.services.graphHelperSvc.mxStyleApply(
      mxStyles,
      ourStyles,
      styleChange.mxKey,
      isCustom,
      styleChange.style,
      'sticker'
    );
  }
}
